import { GWInsuredEvent } from './gw-insured-event.model';
import { FeatureToggles } from './feature-toggles.enum';

export class GWEmailQuoteRequest {
    public email: string;
    public event: GWInsuredEvent;
    public message: string;
    public agentCode: string;
    public agentName: string;
    public featureToggles?: FeatureToggles[];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-email-quote-request.model.ts